module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    attrs: {
      "offset": 4,
      "span": 16
    }
  }, [_c('logo', {
    attrs: {
      "title": _vm.translate.title,
      "primary-color": _vm.primaryColor
    }
  }), _vm._v(" "), (_vm.state === 'reset') ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.translate.subtitle))]), _vm._v(" "), _c('table', {
    staticStyle: {
      "margin": "auto",
      "width": "90%"
    },
    attrs: {
      "role": "presentation",
      "aria-hidden": "true",
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left",
      "font-weight": "bold",
      "padding": "1.2em 0.8em"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.translate.pw_new1)), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pw_new1),
      expression: "pw_new1"
    }],
    staticClass: "input password-input",
    staticStyle: {
      "margin": "auto",
      "width": "90%",
      "border-style": "none none solid none",
      "border-bottom-color": "rgb(210, 210, 210)"
    },
    attrs: {
      "placeholder": _vm.translate.pw_new1_ph,
      "type": "password"
    },
    domProps: {
      "value": (_vm.pw_new1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pw_new1 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left",
      "font-weight": "bold",
      "padding": "1.2em 0.8em"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.translate.pw_new2)), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pw_new2),
      expression: "pw_new2"
    }],
    staticClass: "input password-input",
    staticStyle: {
      "margin": "auto",
      "width": "90%",
      "border-style": "none none solid none",
      "border-bottom-color": "rgb(210, 210, 210)"
    },
    attrs: {
      "placeholder": _vm.translate.pw_new2_ph,
      "type": "password"
    },
    domProps: {
      "value": (_vm.pw_new2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pw_new2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [(_vm.reset_error1) ? _c('td', {
    staticClass: "reset_error"
  }, [_c('h3', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.translate.length_warn))]), _vm._v("\n            " + _vm._s(_vm.translate.length_desc) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.reset_error2) ? _c('td', {
    staticClass: "reset_error"
  }, [_c('h3', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.translate.not_match))]), _vm._v("\n            " + _vm._s(_vm.translate.not_match_desc) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.reset_error3) ? _c('td', {
    staticClass: "reset_error"
  }, [_c('h3', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.translate.server_error))]), _vm._v("\n            " + _vm._s(_vm.translate.server_error_desc) + "\n          ")]) : _vm._e()])]), _vm._v(" "), _c('button', {
    style: ({
      background: _vm.primaryColor,
      'border-color': _vm.primaryColor
    }),
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.translate.reset_button))])]) : _vm._e(), _vm._v(" "), (_vm.state === 'expired') ? _c('p', [_vm._v(_vm._s(_vm.translate.link_expired))]) : _vm._e(), _vm._v(" "), (_vm.state === 'done') ? _c('p', [_vm._v(_vm._s(_vm.updateAppName(_vm.translate.reset_done)))]) : _vm._e(), _vm._v(" "), _c('company', {
    attrs: {
      "name": _vm.footer.companyName,
      "url": _vm.footer.companyUrl,
      "address": _vm.footer.companyAddress,
      "contact": _vm.footer.companyContact,
      "primary-color": _vm.primaryColor,
      "lang": _vm.lang
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-effde368","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/assets/pages/Reset/Reset.vue
// module id = 986
// module chunks = 3